import React from "react";
import { Bar } from "react-chartjs-2";

export default function Chart({ state }) {
  const typeAppointmentNames = state.averageTime.map(e => e.appointmentName);
  const averageDurations = state.averageTime.map(e => e.averageDuration);
  const expectedDurations = state.averageTime.map(e => e.expectedDuration);

  const src = {
    data: {
      labels: typeAppointmentNames,
      datasets: [
        {
          label: "Optimo",
          data: expectedDurations,
          backgroundColor: "#1A73D2"
        },
        {
          label: "Promedio",
          data: averageDurations,
          fill: false,
          backgroundColor: "#DF681B"
        }
      ]
    },
    options: {
      scales: {
        yAxes: [
          {
            ticks: {
              callback: value => {
                return value % 1 === 0 ? Math.floor(value) : null;
              },
              min: 0
            }
          }
        ]
      }
    }
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <Bar
        data={src.data}
        options={src.options}
        // height={30}
        // width={80}
      />
    </div>
  );
}
